import { DefaultDataServiceConfig, EntityMetadataMap } from '@ngrx/data';
import { environment } from '../../environments/environment';
import { entityName as accrualPeriodName } from './accrual-period/accrual-period.data-service';
import { entityName as addressName } from './address/address.data-service';
import { entityName as budgetCycleClassName } from './budget-cycle/budget-cycle.data-service';
import { entityName as budgetLevelClassName } from './budget-level/budget-level.data-service';
import { entityName as burdenName } from './burden/burden.data-service';
import { entityName as companyAccessName } from './company-access/company-access.data-service';
import { entityName as companyCalendarName } from './company-calendar/company-calendar.data-service';
import { entityName as contractName } from './contract/contract.data-service';
import { entityName as contractSummaryName } from './contract/summary/contract-summary.data-service';
import { entityName as deferBillingName } from './defer-billing/defer-billing.data-service';
import { entityName as emailAuditName } from './email-audit/email-audit.data-service';
import { entityName as feeHistoryName } from './fee-history/fee-history.data-service';
import { entityName as feeLevelName } from './fee-level/fee-level.data-service';
import { entityName as feeonGAName } from './fee-level/fee-on-ga/fee-on-ga.data-service';
import { entityName as indirectRateHistoryName } from './indirect-rate-history/indirect-rate-history.data-service';
import { entityName as indirectRateReviewName } from './indirect-rate-review/indirect-rate-review.data-service';
import { entityName as invoiceContractCycleName } from './invoice-contract-cycle/invoice-contract-cycle.data-service';
import { entityName as invoiceAddressSetupName } from './invoice/setup/address/invoice-address-setup.data-service';
import { entityName as invoiceAddressTypeName } from './invoice/setup/invoice-address-type/invoice-address-type.data-service';
import { entityName as invoiceDetailOptionsName } from './invoice/setup/invoice-detail-options/invoice-detail-options.data-service';
import { entityName as invoicePropertyName } from './invoice/setup/invoice-property/invoice-property.data-service';
import { entityName as invoiceSessionTypeName } from './invoice/setup/invoice-session-type/invoice-session-type.data-service';
// import { entityName as reconciliationTimecardName } from './reconciliation/reconciliation-timecard/reconciliation-timecard.data-service';
// import { entityName as reconciliationPayperiodLaborName } from './reconciliation/reconciliation-pay-period-labor/reconciliation-pay-period-labor.data-service';
import { entityName as invoiceSetupName } from './invoice/setup/invoice/invoice-setup.data-service';
import { entityName as invoiceSelectionSetupName } from './invoice/setup/selections/invoice-selections.data-service';
import { entityName as invoiceSessionSetupName } from './invoice/setup/session/invoice-session-setup.data-service';
import { entityName as jobAuditName } from './job-audit/job-audit.data-service';
import { entityName as manageUsersName } from './manage-users/manage-users.data-service';
import { entityName as manualAdjustmentName } from './manual-adjustment/manual-adjustment.data-service';
import { entityName as payrateOverrideName } from './payrate-override/payrate-override.data-service';
// import { entityName as reconciliationTimecardName } from './reconciliation/reconciliation-timecard/reconciliation-timecard.data-service';
// import { entityName as reconciliationPayperiodLaborName } from './reconciliation/reconciliation-pay-period-labor/reconciliation-pay-period-labor.data-service';
import { entityName as premiumPayName } from './premium-pay/premium-pay.data-service';
import { entityName as projectBudgetName } from './project-budget/project-budget.data-service';
import { entityName as policyAssignmentName } from './pto-policy/assignment/pto-policy-assignment.data-service';
import { entityName as policySetupName } from './pto-policy/setup/pto-policy.data-service';
import { entityName as rateCeilingName } from './rate-ceiling/rate-ceiling.data-service';
import { entityName as recalculateContractsName } from './recalculate-transactions/recalculate-contracts/recalculate-contracts.data-service';
import { entityName as recalculateSchedulesName } from './recalculate-transactions/recalculate-schedules/recalculate-schedules.data-service';
import { entityName as recalculateSettingsName } from './recalculate-transactions/recalculate-settings/recalculate-settings.data-service';
import { entityName as reconciliationFieldName } from './reconciliation/reconciliation-fields/reconciliation-field.data-service';
import { entityName as reconciliationTemplateName } from './reconciliation/reconciliation-templates/reconciliation-template.data-service';
import { entityName as reconciliationName } from './reconciliation/reconciliation.data-service';
import { entityName as serviceItemHistoryName } from './service-item/history/service-item-history.data-service';
import { entityName as signaturePolicyName } from './signature-policy/signature-policy.data-service';
import { entityName as timecardClassName } from './timecard-class/timecard-class.data-service';
import { entityName as timecardSequenceName } from './timecard-sequence/timecard-sequence.data-service';
import { entityName as chargeNumberName } from './chargenumber/chargenumber.data-service';
import { entityName as invoiceRegisterName } from './invoice-register/invoice-register.data-service';
import { entityName as jobTimerName } from './job-timer/job-timer.data-service';
import { entityName as toasterName } from './toaster/toaster.data-service';
import { entityName as roleStatusName } from './dashboard/status/role-status.data-service';
import { entityName as fundingName } from './dashboard/funding/funding.data-service';
import { entityName as drStatusName } from './dashboard/dr-status/dr-status.data-service';
import { entityName as accrualName } from './dashboard/accrual/accrual.data-service';
import { entityName as employeePayrollItemName } from './employee-payroll-item/employee-payroll-item.data-service';
import { entityName as dashboardSettingsName } from './dashboard-settings/dashboard-settings.data-service';
import { entityName as ratePlanningName } from './rate-planning/rate-planning.data-service';
import { entityName as indirectRateAdjustName } from './indirect-rate-adjust/indirect-rate-adjust.data-service';
import { entityName as registrationName } from './registration/registration.data-service';
import { entityName as vendorName } from './vendor/vendor.data-service';
import { entityName as payrollExportName } from './payroll/payroll-export/payroll-export.data-service';
import { entityName as mergeName } from './merge/merge.data-service';
import { entityName as invoiceName } from './invoice/invoice.data-service';
import { entityName as cumulativeUploadName } from './cumulative-upload/cumulative-upload.data-service';
import { entityName as employeeValidationName } from './employee-validation/employee-validation.data-service';
import { entityName as payrollValidationName} from './payroll-validation/payroll-validation.data-service';
//import { entityName as taskTimerName } from './task-timer/task-timer.data-service';
//  https://ngrx.io/api/data/EntityDispatcherDefaultOptions
const defaultDispatchOptions = {
    optimisticAdd: false,
    optimisticDelete: false,
    optimisticUpdate: false,
    optimisticUpsert: false,
    optimisticSaveEntities: false
};
const entityMetadata: EntityMetadataMap = {
    // [reconciliationTimecardName]: {},
    // [reconciliationPayperiodLaborName]: {},
    [premiumPayName]: { entityDispatcherOptions: defaultDispatchOptions },
    [payrateOverrideName]: { entityDispatcherOptions: defaultDispatchOptions },
    [projectBudgetName]: { entityDispatcherOptions: defaultDispatchOptions },
    [contractName]: { entityDispatcherOptions: defaultDispatchOptions },
    [contractSummaryName]: { entityDispatcherOptions: defaultDispatchOptions },
    [timecardClassName]: { entityDispatcherOptions: defaultDispatchOptions },
    [budgetLevelClassName]: { entityDispatcherOptions: defaultDispatchOptions },
    [budgetCycleClassName]: { entityDispatcherOptions: defaultDispatchOptions },
    [feeLevelName]: { entityDispatcherOptions: defaultDispatchOptions },
    [feeHistoryName]: { entityDispatcherOptions: defaultDispatchOptions },
    [signaturePolicyName]: { entityDispatcherOptions: defaultDispatchOptions },
    [reconciliationName]: { entityDispatcherOptions: defaultDispatchOptions },
    [reconciliationFieldName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [reconciliationTemplateName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [companyCalendarName]: { entityDispatcherOptions: defaultDispatchOptions },
    [serviceItemHistoryName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [manualAdjustmentName]: { entityDispatcherOptions: defaultDispatchOptions },
    // [reconciliationTimecardName]: {},
    // [reconciliationPayperiodLaborName]: {},
    [invoiceSetupName]: { entityDispatcherOptions: defaultDispatchOptions },
    [invoiceAddressSetupName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [invoiceSelectionSetupName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [invoiceSessionSetupName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [addressName]: { entityDispatcherOptions: defaultDispatchOptions },
    [invoiceSessionTypeName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [invoiceAddressTypeName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [invoicePropertyName]: { entityDispatcherOptions: defaultDispatchOptions },
    [companyAccessName]: { entityDispatcherOptions: defaultDispatchOptions },
    [recalculateSchedulesName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [recalculateContractsName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [recalculateSettingsName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [indirectRateReviewName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [deferBillingName]: { entityDispatcherOptions: defaultDispatchOptions },
    [manageUsersName]: { entityDispatcherOptions: defaultDispatchOptions },
    [feeonGAName]: { entityDispatcherOptions: defaultDispatchOptions },
    [accrualPeriodName]: { entityDispatcherOptions: defaultDispatchOptions },
    [policySetupName]: { entityDispatcherOptions: defaultDispatchOptions },
    [policyAssignmentName]: { entityDispatcherOptions: defaultDispatchOptions },
    [emailAuditName]: { entityDispatcherOptions: defaultDispatchOptions },
    [burdenName]: { entityDispatcherOptions: defaultDispatchOptions },
    [jobAuditName]: { entityDispatcherOptions: defaultDispatchOptions },
    [rateCeilingName]: { entityDispatcherOptions: defaultDispatchOptions },
    [indirectRateHistoryName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [timecardSequenceName]: { entityDispatcherOptions: defaultDispatchOptions },
    [invoiceContractCycleName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [invoiceDetailOptionsName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [chargeNumberName]: { entityDispatcherOptions: defaultDispatchOptions },
    [invoiceRegisterName]: { entityDispatcherOptions: defaultDispatchOptions },
    [jobTimerName]: { entityDispatcherOptions: defaultDispatchOptions },
    [toasterName]: { entityDispatcherOptions: defaultDispatchOptions },
    [roleStatusName]: { entityDispatcherOptions: defaultDispatchOptions },
    [fundingName]: { entityDispatcherOptions: defaultDispatchOptions },
    [drStatusName]: { entityDispatcherOptions: defaultDispatchOptions },
    [accrualName]: { entityDispatcherOptions: defaultDispatchOptions },
    [employeePayrollItemName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [dashboardSettingsName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [ratePlanningName]: { entityDispatcherOptions: defaultDispatchOptions },
    [indirectRateAdjustName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [registrationName]: { entityDispatcherOptions: defaultDispatchOptions },
    [vendorName]: { entityDispatcherOptions: defaultDispatchOptions },
    [payrollExportName]: { entityDispatcherOptions: defaultDispatchOptions },
    [mergeName]: { entityDispatcherOptions: defaultDispatchOptions },
    [invoiceName]: { entityDispatcherOptions: defaultDispatchOptions },
    [cumulativeUploadName]: { entityDispatcherOptions: defaultDispatchOptions },
    //[taskTimerName]: { entityDispatcherOptions: defaultDispatchOptions },
    [employeeValidationName]: {
        entityDispatcherOptions: defaultDispatchOptions
    },
    [payrollValidationName]: { entityDispatcherOptions: defaultDispatchOptions }
};

const collectionNames = {
    // [reconciliationTimecardName]: reconciliationTimecardName,
    // [reconciliationPayperiodLaborName]: reconciliationPayperiodLaborName,
    [premiumPayName]: premiumPayName,
    [payrateOverrideName]: payrateOverrideName,
    [projectBudgetName]: projectBudgetName,
    [contractName]: contractName,
    [contractSummaryName]: contractSummaryName,
    [timecardClassName]: timecardClassName,
    [budgetLevelClassName]: budgetLevelClassName,
    [budgetCycleClassName]: budgetCycleClassName,
    [feeLevelName]: feeLevelName,
    [feeHistoryName]: feeHistoryName,
    [signaturePolicyName]: signaturePolicyName,
    [reconciliationName]: reconciliationName,
    [reconciliationFieldName]: reconciliationFieldName,
    [reconciliationTemplateName]: reconciliationTemplateName,
    [companyCalendarName]: companyCalendarName,
    [serviceItemHistoryName]: serviceItemHistoryName,
    [manualAdjustmentName]: manualAdjustmentName,
    // [reconciliationTimecardName]: reconciliationTimecardName,
    // [reconciliationPayperiodLaborName]: reconciliationPayperiodLaborName,
    [invoiceSetupName]: invoiceSetupName,
    [invoiceAddressSetupName]: invoiceAddressSetupName,
    [invoiceSelectionSetupName]: invoiceSelectionSetupName,
    [invoiceSessionSetupName]: invoiceSessionSetupName,
    [addressName]: addressName,
    [invoiceSessionTypeName]: invoiceSessionTypeName,
    [invoiceAddressTypeName]: invoiceAddressTypeName,
    [invoicePropertyName]: invoicePropertyName,
    [companyAccessName]: companyAccessName,
    [recalculateSchedulesName]: recalculateSchedulesName,
    [recalculateContractsName]: recalculateContractsName,
    [recalculateSettingsName]: recalculateSettingsName,
    [indirectRateReviewName]: indirectRateReviewName,
    [deferBillingName]: deferBillingName,
    [manageUsersName]: manageUsersName,
    [feeonGAName]: feeonGAName,
    [accrualPeriodName]: accrualPeriodName,
    [policySetupName]: policySetupName,
    [policyAssignmentName]: policyAssignmentName,
    [emailAuditName]: emailAuditName,
    [burdenName]: burdenName,
    [jobAuditName]: jobAuditName,
    [rateCeilingName]: rateCeilingName,
    [indirectRateHistoryName]: indirectRateHistoryName,
    [timecardSequenceName]: timecardSequenceName,
    [invoiceContractCycleName]: invoiceContractCycleName,
    [invoiceDetailOptionsName]: invoiceDetailOptionsName,
    [chargeNumberName]: chargeNumberName,
    [invoiceRegisterName]: invoiceRegisterName,
    [jobTimerName]: jobTimerName,
    [toasterName]: toasterName,
    [roleStatusName]: roleStatusName,
    [fundingName]: fundingName,
    [drStatusName]: drStatusName,
    [accrualName]: accrualName,
    [employeePayrollItemName]: employeePayrollItemName,
    [dashboardSettingsName]: dashboardSettingsName,
    [ratePlanningName]: ratePlanningName,
    [indirectRateAdjustName]: indirectRateAdjustName,
    [registrationName]: registrationName,
    [vendorName]: vendorName,
    [payrollExportName]: payrollExportName,
    [mergeName]: mergeName,
    [invoiceName]: invoiceName,
    [cumulativeUploadName]: cumulativeUploadName,
    //[taskTimerName]: taskTimerName,
    [employeeValidationName]: employeeValidationName,
    [payrollValidationName]: payrollValidationName
};

export const entityConfig = {
    entityMetadata,
    pluralNames: collectionNames
};
export const defaultDataServiceConfig: DefaultDataServiceConfig = {
    root: environment.apiLocation
    // timeout: 3000, // request timeout
};
